<template>
  <el-form label-width="180px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="等级名称" required>
      <el-input v-model="form.title" />
    </el-form-item>
    <el-form-item label="收益加成" required>
      <el-input v-model="form.extra"> <template #append>%</template> </el-input>
    </el-form-item>
    <el-form-item label="累计认购金额" required>
      <el-input v-model="form.total_committed_amount" />
    </el-form-item>
    <el-form-item label="每日抽奖次数" required>
      <el-input v-model="form.draws_num" />
    </el-form-item>
    <el-form-item label="余额宝利率" required>
      <el-input v-model="form.yue_bao_rate"> <template #append>%</template> </el-input>
    </el-form-item>
  </el-form>
</template>

<script setup>
  import { nextTick, onMounted, ref } from 'vue'

  const form = ref({
    title: '',
    extra: '',
    total_committed_amount: '',
    draws_num: '',
    yue_bao_rate: '',
  })
  const props = defineProps(['item'])

  onMounted(() => {
    nextTick(() => {
      form.value = Object.assign(form, props.item)
    })
  })

  defineExpose({ form })
</script>

<style lang="less" scoped>
  .demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
  }

  .demo-form-inline .el-input {
    --el-input-width: 220px;
  }

  .demo-form-inline .el-select {
    --el-select-width: 220px;
  }

  /deep/ .el-radio-group {
    width: 220px;
  }

  .form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
    width: 100%;
  }

  /deep/ .el-form-item {
    align-items: flex-start;
  }
</style>
